import { render, staticRenderFns } from "./MStoreFormInput.vue?vue&type=template&id=30dae2e0&"
import script from "./MStoreFormInput.vue?vue&type=script&lang=ts&"
export * from "./MStoreFormInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports